import { Grid, GridProps } from "@mui/material";
import React from "react";

export const GridRow = (props: GridProps) => (
    <Grid container spacing={2} {...props}>
        {props.children}
    </Grid>
);
